<template>
    <div class="login-registration">
      <div class="container without-nav">
        <div class="row">
          <div
            class="col-xxs-12 col-xxs-offset-0 col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4"
          >
            <h1 class="page-title">Login</h1>
          </div>
        </div>
      </div>
  
      <div class="container without-nav">
        <div class="row">
          <div
            class="col-xxs-12 col-xxs-offset-0 col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4"
          >
            <form @submit.prevent="login">
              <fieldset class="fieldset">
                <div class="fieldset__item">
                  <label
                    class="fieldset__item__label sg-textfield-label sg-required"
                  >
                    <span class="sg-textfield-label-caption">Email address</span>
                  </label>
                  <input
                    v-model="email"
                    name="email"
                    class="sg-element"
                    type="email"
                    value
                  />
                </div>
                <div class="fieldset__item">
                  <label
                    class="fieldset__item__label sg-textfield-label sg-required"
                    for="password"
                  >
                    <span class="sg-textfield-label-caption">Password</span>
                  </label>
                  <input
                    type="password"
                    name="password"
                    class="sg-element"
                    v-model="password"
                    value
                  />
                </div>
              </fieldset>
              <div class="vrm-panel--form__button-container">
                <button
                  class="sg-btn sg-blue sg-element"
                  type="submit"
                  name="buttonLogin"
                >
                  Login
                </button>
                <div class="flashMessage" v-if="GStore.flashMessage">
                  {{ GStore.flashMessage }}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "LoginView",
    inject: ["GStore"],
  
    data() {
      return {
        email: "",
        password: "",
      };
    },
  
    methods: {
      login() {
        this.$store
          .dispatch("login", {
            email: this.email,
            password: this.password,
          })
          .then(() => {
            this.$router.push("/admin");
          })
          .catch(() => {
            this.GStore.flashMessage = "Invalid email or password!";
  
            setTimeout(() => {
              this.GStore.flashMessage = "";
            }, 3000);
          });
      },
    },
  };
  </script>
  
  <style scoped lang="less"></style>
  